<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-data-table-server
            v-model:options="options"
            v-model:footer-props="footerProps"
            dense
            :headers="headers"
            :loading="loading"
            :items="items"
            item-value="id"
            :items-length="totalItems"
            class="elevation-1"
            @update:options="updateTable"
          >
            <template #top>
              <v-card-title>
                <v-toolbar flat>
                  <v-toolbar-title>Communication History</v-toolbar-title>
                  <v-spacer />
                  <v-tooltip bottom>
                    <template #activator="{ props }">
                      <v-btn
                        class="btn-bg-deep-blue"
                        :href="dripUrl"
                        target="_blank"
                        v-bind="props"
                      >
                        <v-icon
                          left
                          dark
                        >
                          mdi-water
                        </v-icon>
                        Drip History
                      </v-btn>
                    </template>
                    <span>{{ tooltipText }}</span>
                  </v-tooltip>
                </v-toolbar>
              </v-card-title>
            </template>

            <template #item.actions="{ item }">
              <v-btn
                x-small
                color="primary"
                @click="openEmailModal(item)"
              >
                <v-icon left dark>
                  mdi-eye
                </v-icon>
                View
              </v-btn>
            </template>
          </v-data-table-server>
        </v-card>

        <!-- Email Details Modal -->
        <v-dialog
          v-model="showEmailModal"
          max-width="800px"
        >
          <v-card v-if="selectedEmail">
            <v-card-title>
              <span class="text-h5">Email Details</span>
              <v-spacer />
              <v-btn
                icon
                @click="closeEmailModal"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <strong>Email:</strong> {{ parseNoteData(selectedEmail.note_data).email || 'N/A' }}
                </v-col>
                <v-col
                  v-if="parseNoteData(selectedEmail.note_data).subject"
                  cols="12"
                >
                  <strong>Subject:</strong> {{ parseNoteData(selectedEmail.note_data).subject }}
                </v-col>
                <v-col cols="12">
                  <strong>Date/Time:</strong> {{ selectedEmail.created }}
                </v-col>
                <v-col cols="12">
                  <strong>Author:</strong> {{ selectedEmail.create_user_name }}
                </v-col>
                <v-col
                  v-if="parseNoteData(selectedEmail.note_data).body"
                  cols="12"
                >
                  <v-divider class="my-4" />
                  <strong>Message:</strong>
                  <div
                    class="mt-2"
                    style="white-space: pre-wrap;"
                  >
                    {{ parseNoteData(selectedEmail.note_data).body }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="closeEmailModal"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DateTime } from 'luxon';
import dataTableMixin from '@/mixins/dataTableMixin.js';

export default {
  name: 'LoanProCustomerProfile',
  mixins: [
    dataTableMixin,
  ],
  props: {
    customer: {
      type: Object,
      required: true,
    },
    customerLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { title: 'Date/Time', key: 'created', width: 180 },
        { title: 'Note/Email', key: 'note_title' },
        { title: 'Author', key: 'create_user_name', width: 150 },
        {
          title: 'Actions', key: 'actions', width: 120, sortable: false,
        },
      ],
      dripUrl: null,
      showEmailModal: false,
      selectedEmail: null,
    };
  },
  computed: {
    tooltipText() {
      return this.dripUrl
        ? 'Click to open this customers drip emails in a new window.'
        : 'This customer was not found in drip.';
    },
  },
  watch: {
    customerLoading() {
      if (!this.customerLoading && !this.dripUrl) {
        this.fetchDripUrl();
      }
    },
  },
  created() {
    if (this.customer.email && !this.dripUrl) {
      this.fetchDripUrl();
    }
  },
  methods: {
    async updateTable() {
      this.loading = true;

      const response = await this.$axios
        .get(`api/v1/loanpro-customer/${this.$route.params.customer_id}/emails`, {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        });

      this.totalItems = response.data.total;

      // Format dates before assigning items
      this.items = response.data.data.map((item) => ({
        ...item,
        created: this.createDate(item.created),
      }));

      this.loading = false;
    },
    async fetchDripUrl() {
      const response = await this.$axios.get(`api/v1/drip/get-url?email=${encodeURIComponent(this.customer.email)}`);
      if (response.status === 200 && response.data.url) {
        this.dripUrl = response.data.url;
      }
    },
    createDate(date) {
      return DateTime.fromSQL(date).toLocaleString(DateTime.DATETIME_MED);
    },
    openEmailModal(item) {
      this.selectedEmail = item;
      this.showEmailModal = true;
    },
    closeEmailModal() {
      this.showEmailModal = false;
      this.selectedEmail = null;
    },
    parseNoteData(noteData) {
      try {
        return JSON.parse(noteData);
      } catch (e) {
        return {};
      }
    },
  },
};
</script>
